var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavingsCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13C6.67392 13 5.40215 12.4732 4.46447 11.5355C3.52678 10.5979 3 9.32608 3 8C3 6.67392 3.52678 5.40215 4.46447 4.46447C5.40215 3.52678 6.67392 3 8 3C9.32608 3 10.5979 3.52678 11.5355 4.46447C12.4732 5.40215 13 6.67392 13 8C13 9.32608 12.4732 10.5979 11.5355 11.5355C10.5979 12.4732 9.32608 13 8 13ZM8.8525 6.1475L7.5075 8.71625L6.54312 7.8475C6.4821 7.79259 6.41086 7.75024 6.33347 7.72286C6.25608 7.69549 6.17405 7.68362 6.09208 7.68794C6.0101 7.69227 5.92978 7.7127 5.85569 7.74806C5.78161 7.78343 5.71522 7.83304 5.66031 7.89406C5.6054 7.95509 5.56305 8.02633 5.53568 8.10372C5.5083 8.18111 5.49643 8.26314 5.50076 8.34511C5.50508 8.42709 5.52551 8.50741 5.56087 8.58149C5.59624 8.65558 5.64585 8.72197 5.70688 8.77688L7.26938 10.1831C7.34017 10.2469 7.42461 10.2936 7.51623 10.3197C7.60785 10.3459 7.70423 10.3507 7.798 10.3339C7.89178 10.3171 7.98047 10.279 8.05729 10.2227C8.13411 10.1663 8.19704 10.0931 8.24125 10.0087L9.96 6.7275C10.0369 6.58064 10.0523 6.40923 10.0029 6.251C9.95341 6.09277 9.84311 5.96066 9.69625 5.88375C9.54939 5.80684 9.37798 5.79142 9.21975 5.84088C9.06152 5.89034 8.92941 6.00064 8.8525 6.1475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingsCheck);
export default __webpack_public_path__ + "static/media/savingsCheck.908c9abd4d7f37290a72b930801e0bfa.svg";
export { ForwardRef as ReactComponent };